import { ActionType, createReducer } from 'typesafe-actions';
import * as actions from './actions';
import { ClassDigitalNotebook } from './type';

type ClassDigitalNotesFeatureActions = ActionType<typeof actions>;

const initialState: ClassDigitalNotebook = {
  selectedClass: '',
  selectedLesson: '',
};

const reducer = createReducer<
  ClassDigitalNotebook,
  ClassDigitalNotesFeatureActions
>(initialState)
  .handleAction(actions.setSelectedClass, (state, { payload }) => ({
    ...state,
    selectedClass: payload.selectedClass,
  }))
  .handleAction(actions.setSelectedLessons, (state, { payload }) => ({
    ...state,
    selectedLesson: payload.selectedLesson,
  }));

export default reducer;
